import { TTypeOfCodec, TTypeOfNewDefault } from "../../../shared/src/codecs/codec";
import { required } from "../../../shared/src/codecs/types/required";
import { uuid } from "../../../shared/src/codecs/types/uuid";
import { form } from "../../../shared/src/codecs/types/form";
import { dateTime } from "../../../shared/src/codecs/types/dateTime";
import { EmptyObject } from "../EmptyObject";

export const SendListingToAuctionForm = form(
    required({
        listing_id: uuid(),
        went_to_auction_date: dateTime(),
    }),
    EmptyObject,
);

export type TSendListingToAuctionFormCodec = typeof SendListingToAuctionForm;
export type TSendListingToAuctionForm = TTypeOfCodec<TSendListingToAuctionFormCodec>;
export type TSendListingToAuctionFormNewDefault = TTypeOfNewDefault<TSendListingToAuctionFormCodec>;
